export default {
  amabla_token: process.env.VUE_APP_AMABLA_TOKEN,
  amabla_url: process.env.VUE_APP_AMABLA_URL,
  api_host: process.env.VUE_APP_API_HOST,
  app_i18n_locale: process.env.VUE_APP_I18N_LOCALE,
  app_i18n_fallback_locale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
  app_version: process.env.VUE_APP_VERSION,
  base_url: process.env.VUE_APP_BASE_URL,
  cookie_domain: process.env.VUE_APP_COOKIE_DOMAIN,
  desk_v1_host: process.env.VUE_APP_DESK_V1_HOST,
  help_nomination_url: process.env.VUE_APP_HELP_NOMINATION_URL,
  intercom_app_id: process.env.VUE_APP_INTERCOM_APP_ID,
  intercom_widget_authorized_url: [
    'app-v2.nomination.fr',
    'app.nomination.fr',
  ],
  posthog: {
    api_host: process.env.VUE_APP_POSTHOG_API_HOST,
    api_token: process.env.VUE_APP_POSTHOG_API_TOKEN,
  },
  // Missing environment is treated as production.
  get chatbot_environment() {
    try {
      return new URL(process.env.VUE_APP_API_HOST).hostname;
    } catch {
      return 'desk-api.nomination.fr';
    }
  },
};
